import { render } from "./my-input.vue?vue&type=template&id=28b25094&scoped=true"
import script from "./my-input.vue?vue&type=script&lang=js"
export * from "./my-input.vue?vue&type=script&lang=js"

import "./my-input.vue?vue&type=style&index=0&id=28b25094&lang=scss&scoped=true"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b25094"]])

export default __exports__